import * as ActionTypes from "../actions/actionTypes";
import { initialGlobalStore, initialLocalStore, initialState, } from "./initialState";
export const basicReducer = (prevState, action) => {
    if (prevState)
        switch (action.type) {
            case ActionTypes.SET_GLOBAL_STORE:
                return Object.assign(Object.assign({}, prevState), { globalStore: action.payload });
            case ActionTypes.SET_LOCAL_STORE:
                return Object.assign(Object.assign({}, prevState), { localStore: action.payload });
            case ActionTypes.SET_LOCAL_STORE_ITEM:
                return Object.assign(Object.assign({}, prevState), { localStore: Object.assign(Object.assign({}, prevState.localStore), { [action.payload.id]: action.payload.localStoreItem }) });
            case ActionTypes.SET_PROFILE:
                return Object.assign(Object.assign({}, prevState), { globalStore: { profile: action.payload } });
            case ActionTypes.SET_TABLE_SETTINGS:
                return Object.assign(Object.assign({}, prevState), { localStore: Object.assign(Object.assign({}, prevState.localStore), { [action.payload.id]: Object.assign(Object.assign({}, prevState.localStore[action.payload.id]), { tableSettings: action.payload.tableSettings }) }) });
            case ActionTypes.SET_FILTERS:
                return Object.assign(Object.assign({}, prevState), { localStore: Object.assign(Object.assign({}, prevState.localStore), { [action.payload.id]: Object.assign(Object.assign({}, prevState.localStore[action.payload.id]), { filters: action.payload.filters }) }) });
            case ActionTypes.LOG_OUT:
                return initialState;
            case ActionTypes.CHANGE_LOCATION:
                return Object.assign(Object.assign({}, prevState), { localStore: initialLocalStore });
            case ActionTypes.RESET_GLOBAL_STORE:
                return Object.assign(Object.assign({}, prevState), { globalStore: initialGlobalStore });
            default:
                return prevState;
        }
    else
        return initialState;
};
//# sourceMappingURL=index.js.map